// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_ne6","cls2":"MultiPaperNewsStory-cls2_vQN MultiPaperNewsStory-cls1_ne6"};